import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, Sparkles, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const DemoBanner = () => {
  const navigate = useNavigate();

  return (
    <div className="mb-4 px-4 py-2.5 rounded-lg bg-amber-500/10 border border-amber-500/20 flex items-center justify-between gap-3" data-testid="demo-banner">
      <div className="flex items-center gap-2 min-w-0">
        <Eye className="w-4 h-4 text-amber-400 flex-shrink-0" />
        <p className="text-sm text-amber-300">
          <span className="font-medium">Proyecto de ejemplo</span>
          <span className="text-amber-300/70 ml-1.5 hidden sm:inline">— Solo lectura. Suscribete para crear tus propios proyectos.</span>
        </p>
      </div>
      <Button
        size="sm"
        onClick={() => navigate('/pricing')}
        className="bg-amber-500/20 hover:bg-amber-500/30 text-amber-300 border border-amber-500/30 gap-1.5 flex-shrink-0"
        data-testid="demo-banner-cta"
      >
        <Sparkles className="w-3 h-3" />
        Ver planes
      </Button>
    </div>
  );
};

export default DemoBanner;
